import type { GridPosition, PresentedLineWin, PresentationMode } from '../rendering/types';

export type PresentationEvent =
  | { readonly type: 'spin-start'; readonly mode: PresentationMode; readonly turbo: boolean }
  | { readonly type: 'shuffle'; readonly mode: PresentationMode }
  | { readonly type: 'deal-complete'; readonly mode: PresentationMode }
  | { readonly type: 'reel-reveal-start'; readonly reel: number }
  | { readonly type: 'anticipation-start'; readonly reel: number; readonly stage: 2 | 3 }
  | { readonly type: 'reel-stop'; readonly reel: number; readonly scatterStage: 0 | 1 | 2 | 3; readonly hasScatter: boolean; readonly hasNewWild: boolean }
  | { readonly type: 'line-show'; readonly line: PresentedLineWin; readonly ordinal: number; readonly total: number }
  | { readonly type: 'sticky-reveal'; readonly positions: readonly GridPosition[] }
  | { readonly type: 'god-activation'; readonly god: 'RA' | 'SLIFER' | 'OBELISK' }
  | { readonly type: 'pot-highlight'; readonly position: GridPosition }
  | { readonly type: 'pot-awarded'; readonly position: GridPosition; readonly awarded: 1 }
  | { readonly type: 'pot-flip'; readonly position: GridPosition }
  | { readonly type: 'pot-transformed'; readonly position: GridPosition }
  | { readonly type: 'retrigger'; readonly awarded: number }
  | { readonly type: 'presentation-complete' };

export interface PresentationEventSink {
  emit(event: PresentationEvent): void;
}

export const NOOP_PRESENTATION_SINK: PresentationEventSink = Object.freeze({
  emit: () => undefined,
});
